import React from 'react';

import Button from '../../Components/Button';

class ReportsLanding extends React.Component {
    constructor(props) {
        super(props);

        this.handleReportPathHover = this.handleReportPathHover.bind(this);
        this.getDetailsDisplay = this.getDetailsDisplay.bind(this);

        this.state = {
            reportHoverVisible: {
                'condition-details': '',
                'authoring-status': ''
            }
        };
    }

    handleReportPathHover(val, e, mouseIn) {
        if (val && mouseIn) {
            this.setState({
                reportHoverVisible: {
                    ...{
                        'condition-details': '',
                        'authoring-status': ''
                    },
                    ...{
                        [val]: 'visible'
                    }
                }
            });
        } else {
            this.setState({
                reportHoverVisible: {
                    'condition-details': '',
                    'authoring-status': ''
                }
            });
        }
    }

    getDetailsDisplay(val) {
        switch (val) {
            case 'authoring-status':
                return (
                    <div>
                        <div className="headline">Jurisdiction Report containing</div>
                        <div className="includes">
                            <div>Public Health Agency Details</div>
                            <div>Condition List</div>
                            <div>Zip Codes</div>
                            <div>Contact Information</div>
                            <div>Responsible Agency, by Condition</div>
                            <div>External Links and References by Condition</div>
                        </div>
                    </div>
                );
            case 'condition-details':
                return (
                    <div>
                        <div className="headline">Condition Report containing</div>
                        <div className="includes">
                            <div>Condition Details</div>
                            <div>Reporting Specification Status</div>
                            <div>Reporting Preferences</div>
                            <div>Links and References</div>
                            <div>Logic Set Details</div>
                            <div>Criteria List</div>
                            <div>Concept and Value Sets</div>
                        </div>
                        <div>Available for Default and Jurisdictional Reporting Specifications</div>
                    </div>
                );
            case 'all-value-sets-concepts':
                return (
                    <div>
                        <div className="headline">RCKMS Admin Report containing</div>
                        <div className="includes">
                            <div>Value Set Name</div>
                            <div>Object Id</div>
                            <div>Status</div>
                            <div>Version</div>
                            <div>Concept</div>
                        </div>
                    </div>
                );
            case 'all-condition-criteria':
                return (
                    <div>
                        <div className="headline">RCKMS Admin Report containing</div>
                        <div className="includes">
                            <div>Criteria Name and ID</div>
                            <div>Criteria Type</div>
                            <div>Logic Statements</div>
                            <div>Template Name and ID</div>
                        </div>
                    </div>
                );
            case 'all-user-accounts':
                return (
                    <div>
                        <div className="headline">RCKMS Admin Report containing</div>
                        <div className="includes">
                            <div>Username</div>
                            <div>User First Name</div>
                            <div>User Last Name</div>
                            <div>User Email</div>
                            <div>User Role</div>
                            <div>User Jurisdiction</div>
                            <div>Notes</div>
                        </div>
                    </div>
                );
            case 'all-jurisdiction-status':
                return (
                    <div>
                        <div className="headline">RCKMS Admin Report Containing</div>
                        <div className="includes">
                            <div>Jurisdiction Name</div>
                            <div>Condition Name and Version</div>
                            <div>Authoring Status</div>
                        </div>
                    </div>
                );
            case 'all-conditions':
                return (
                    <div>
                        <div className="headline">RCKMS Admin Report Containing</div>
                        <div className="includes">
                            <div>Condition Name and Version</div>
                            <div>Authoring Status</div>
                            <div>Condition Code</div>
                            <div>Condition Category</div>
                            <div>NNC Code</div>
                        </div>
                    </div>
                );
            default:
                return null;
        }
    }

    render() {
        const isAdmin =
            typeof this.props.userContext == 'object' && this.props.userContext.role === 'RCKMS_ADMINISTRATOR';
        return (
            <div className="landing-container">
                <div className="header">Select a Report to Generate</div>
                <div className="report-controls">
                    <div className="buttons">
                        <Button
                            name="authoring-status"
                            onClick={this.props.handleReportPathSelect}
                            onHover={this.handleReportPathHover}
                        >
                            Authoring Status
                        </Button>
                        <Button
                            name="condition-details"
                            onClick={this.props.handleReportPathSelect}
                            onHover={this.handleReportPathHover}
                        >
                            Condition Details
                        </Button>
                        {isAdmin && (
                            <React.Fragment>
                                <Button
                                    name="all-value-sets-concepts"
                                    onClick={this.props.handleReportPathSelect}
                                    onHover={this.handleReportPathHover}
                                >
                                    All Value Sets & Concepts Export
                                </Button>
                                <Button
                                    name="all-condition-criteria"
                                    onClick={this.props.handleReportPathSelect}
                                    onHover={this.handleReportPathHover}
                                >
                                    All Condition Criteria Export
                                </Button>
                                <Button
                                    name="all-jurisdiction-status"
                                    onClick={this.props.handleReportPathSelect}
                                    onHover={this.handleReportPathHover}
                                >
                                    All Jurisdiction Authoring Export
                                </Button>
                                <Button
                                    name="all-conditions"
                                    onClick={this.props.handleReportPathSelect}
                                    onHover={this.handleReportPathHover}
                                >
                                    All Conditions Summary Export
                                </Button>
                                <Button
                                    name="all-user-accounts"
                                    onClick={this.props.handleReportPathSelect}
                                    onHover={this.handleReportPathHover}
                                >
                                    All User Accounts
                                </Button>
                            </React.Fragment>
                        )}
                    </div>
                    <div className="report-description">
                        <div className={`${this.state.reportHoverVisible['authoring-status']}`}>
                            {this.getDetailsDisplay('authoring-status')}
                        </div>
                        <div className={`${this.state.reportHoverVisible['condition-details']}`}>
                            {this.getDetailsDisplay('condition-details')}
                        </div>
                        {isAdmin && (
                            <React.Fragment>
                                <div className={`${this.state.reportHoverVisible['all-value-sets-concepts']}`}>
                                    {this.getDetailsDisplay('all-value-sets-concepts')}
                                </div>
                                <div className={`${this.state.reportHoverVisible['all-condition-criteria']}`}>
                                    {this.getDetailsDisplay('all-condition-criteria')}
                                </div>
                                <div className={`${this.state.reportHoverVisible['all-jurisdiction-status']}`}>
                                    {this.getDetailsDisplay('all-jurisdiction-status')}
                                </div>
                                <div className={`${this.state.reportHoverVisible['all-conditions']}`}>
                                    {this.getDetailsDisplay('all-conditions')}
                                </div>
                                <div className={`${this.state.reportHoverVisible['all-user-accounts']}`}>
                                    {this.getDetailsDisplay('all-user-accounts')}
                                </div>
                            </React.Fragment>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default ReportsLanding;
